import React from "react";
import { withTranslation } from "react-i18next";
import {
  LocalStorageService,
  ContractService,
  CompanyService,
  ClientService
} from "../../../services";
import HelpDeskView from "../../views/help-desk/help-desk.view";
import { REPSEIcon, ProviderREPSE } from "../../../assets/logos/icons";
import { getNavigatorTimezone } from "../../../utils";

class HelpDeskAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      token: "",
      cardHelpDesk: [],
      questionnairesByUser: [],
      cardRepse: false,
      cardHelpDesk: [],
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  contractService = new ContractService(this.url);
  companyService = new CompanyService(this.url);
  clientService = new ClientService(this.url)
  timezone = getNavigatorTimezone()



  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let user = this.localStorageService.getLocalStorageItem("user");
    let userType = user.userMetaData.userRoles;

    const roleIds = [...new Set(userType.map((type) => type.role.id))]

    const [isAdmin, isColab, isInvited] = [roleIds.includes(5), roleIds.includes(6), roleIds.includes(4)]

    if (isAdmin) {
      let finalCardHelpDesk = []
      finalCardHelpDesk.push(
        {
          title: this.props.t("helpDesk.repse.title"),
          text: this.props.t("helpDesk.repse.description"),
          img: REPSEIcon,
          url: "/repse-status-by-company",
          subCards: [
            {
              title: this.props.t("helpDesk.manageREPSEProviders-repse"),
              text: this.props.t("helpDesk.manageREPSEProviders-repse-text"),
              img: ProviderREPSE,
              url: "/contractors-catalog/2"
            },
            {
              title: this.props.t("helpDesk.consultREPSE"),
              text: this.props.t("helpDesk.consultREPSE-text"),
              img: REPSEIcon,
              url: "/repse-status-by-company"
            }
          ]
        },
        {
          title: this.props.t("helpDesk.title.assemblies"),
          text: this.props.t("helpDesk.assemblies.text"),
          img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_ASSEMBLIES}`,
          url: "/assemblies"
        },
        {
          title: this.props.t("helpDesk.manageContractors"),
          text: this.props.t("helpDesk.manageContractors-text"),
          img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_CONTRATANTES}`,
          url: "/contractors-catalog/1",
          subCards: []
        },
        {
          title: this.props.t("helpDesk.card.title.createDocuments"),
          text: this.props.t("helpDesk.card.text.createDocuments"),
          img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_GENERAR_CONTRATO}`,
          url: "/digital-contract/home",
        }
      )

      this.setState({
        cardContractsREPSE: true,
        cardHelpDesk: [...finalCardHelpDesk],
      })
    }

    const haveHelpDeskRoles = [...userType.filter((type) => type.role.groupName === process.env.REACT_APP_GOVO_GROUP_NAME_HELP_DESK)].map((type) => type.role.key);

    if (isColab) {
      let finalCardHelpDesk = []
      if (haveHelpDeskRoles.includes(process.env.REACT_APP_HELP_DESK_ROLE_GOVO_REPSE_ADMIN))
        finalCardHelpDesk.push(
          {
            title: this.props.t("helpDesk.repse.title"),
            text: this.props.t("helpDesk.repse.description"),
            img: REPSEIcon,
            url: "/repse-status-by-company",
            subCards: [
              {
                title: this.props.t("helpDesk.manageREPSEProviders-repse"),
                text: this.props.t("helpDesk.manageREPSEProviders-repse-text"),
                img: ProviderREPSE,
                url: "/contractors-catalog/2"
              },
              {
                title: this.props.t("helpDesk.consultREPSE"),
                text: this.props.t("helpDesk.consultREPSE-text"),
                img: REPSEIcon,
                url: "/repse-status-by-company"
              }
            ]
          })
      if (haveHelpDeskRoles.includes(process.env.REACT_APP_HELP_DESK_ROLE_GOVO_ASSEMBLY_ADMIN))
        finalCardHelpDesk.push(
          {
            title: this.props.t("helpDesk.title.assemblies"),
            text: this.props.t("helpDesk.assemblies.text"),
            img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_ASSEMBLIES}`,
            url: "/assemblies"
          })

      if (haveHelpDeskRoles.includes(process.env.REACT_APP_HELP_DESK_ROLE_GOVO_CONTRACTOR_ADMIN)) finalCardHelpDesk.push(
        {
          title: this.props.t("helpDesk.manageContractors"),
          text: this.props.t("helpDesk.manageContractors-text"),
          img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_CONTRATANTES}`,
          url: "/contractors-catalog/1",
          subCards: []
        },
      )

      this.setState({
        cardContractsREPSE: true,
        cardHelpDesk: [...finalCardHelpDesk,
        {
          title: this.props.t("helpDesk.card.title.createDocuments"),
          text: this.props.t("helpDesk.card.text.createDocuments"),
          img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_GENERAR_CONTRATO}`,
          url: "/digital-contract/home",
        }
        ],
      })
    }

    if (isInvited) this.setState({
      cardRepse: true,
      cardHelpDesk: [
        {
          title: "Reportar repse",
          text: "Revisa, carga y envía a validar tus documentos REPSE.",
          img: REPSEIcon,
          url: `/guest-repse-documents`
        },
      ],
    });

    await this.getClientPreferences()

    try {
      this.setState({
        token: this.token,
        loading: false,
      });
    } catch (error) {
      this.props.history.push("/");
      this.setState({
        cardHelpDesk: [],
        loading: false,
      });
    }
  }

  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 2000);
      }
    );
  };

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleCompletedRequesting = (value, message, questionnaires) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            questionnairesByUser: questionnaires,
          });
          // funcion()
        }, 4000);
      }
    );
  };

  toggleCompletedQuestionsRequesting = (value) => {
    this.setState({
      showCompletedRequesting: value,
    });
  };

  getClientPreferences = async () => {
    try {
      let preferences = await this.clientService.getClientPreferences(this.token, this.timezone);
      if (preferences && preferences.data && Number(preferences.statusCode) === 200) {
        let preferenceProcedureUser = preferences.data.find((preference) => preference.preferenceName === process.env.REACT_APP_PREFERENCE_PROCEDURES_CONTROL)
        let preferenceValue = (preferenceProcedureUser) ? preferenceProcedureUser.booleanValue : false
        if (preferenceValue) {
          let copyCards = [...this.state.cardHelpDesk]
          let freelance = {
            title: this.props.t("helpDesk.freelance.title"),
            text: this.props.t("helpDesk.freelance.description"),
            img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_CLIENTE}`,
            url: "/configuration",
            subCards: [
              {
                title: this.props.t("helpDesk.entities.title"),
                text: this.props.t("helpDesk.entities.description"),
                img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_ENTIDADES}`,
                url: "/entities-administration"
              }
            ]
          }
          copyCards.push(freelance)

          this.setState({
            cardHelpDesk: copyCards
          })
        }
      } else {
        this.props.history.push("/");
        this.setState({
          cardHelpDesk: [],
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push("/");
      this.setState({
        cardHelpDesk: [],
        loading: false,
      });
    }
  }

  render() {
    return (
      <HelpDeskView
        {...this.state}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleCompletedQuestionsRequesting={
          this.toggleCompletedQuestionsRequesting
        }
      />
    );
  }
}

export default withTranslation()(HelpDeskAction);
